import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { DOCUMENT_KINDS, SCREENS } from "utils/constants";
import CreateStatic from "./Static";

const VIEW_BY_KIND = {
  [DOCUMENT_KINDS.STATIC]: () => <CreateStatic />,
};

const Create = () => {
  const { state } = useLocation();
  const View = useMemo(() => VIEW_BY_KIND[state?.kind], [state?.kind]);
  if (!View)
    return <Navigate to={SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.LIST.path} />;
  return View();
};

export default Create;
